<template>
  <div class="scorecard-modal-backdrop">
    <div id="scorecard_modal" class="scorecard-modal" v-if="summary != null">
      <div class="scorecard-scrollbox">
        <div>
          <div class="has-text-right">
            <span>
              <button class="button is-info" @click="exportToPDF">Export to PDF</button>&nbsp;
            </span>
            <span class="is-size-3 btn-close">
              <a @click="close"><i class="fas fa-times-circle"></i></a>
            </span>
          </div>
        </div>
        <div class="has-text-left">
          <Summary :summary="summary"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Summary from "./Summary.vue";
import html2pdf from "html2pdf.js";

// Enable all 'modes', with no explicit elements.
html2pdf().set({
  pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
});

export default {
  name: "SummaryModal",
  props: {
    summary: null
  },
  components: {
    Summary
  },  
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
  },
  methods: {
		exportToPDF() {
      //https://pspdfkit.com/blog/2022/how-to-generate-a-pdf-with-vuejs/
			html2pdf(document.getElementById('game_summary'), { margin: 10, filename: "timberlounge_" + this.summary._id + ".pdf"});
		},    
    close() {
      this.$emit("close");
    }
  },
  mounted(){

  }
};
</script>

<style lang="scss" scoped>
.scorecard-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-Index: 1000;
}
.scorecard-modal, h1, h2, h3, h4, h5, h6 {
  color: black !important;
}

.scorecard-modal {
  font-family: Verdana;
  padding: 5px;
  border-radius: 25px !important;
  background: silver;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 80%;
  height: 80%;
}
.scorecard-scrollbox {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 0px;
  padding-left: 10px;
}
.btn-close {
  display: inline;
  font-size: 2em;
  cursor: pointer;
  font-weight: bold;
}
</style>